/**
 * NOTE that values are called as SearchBox wixcode instance methods
 * this is important because if `registerEvent` helper
 */
export const ACTION_TYPES = {
  ON_INPUT: 'onInput',
  ON_CLEAR: 'onClear',
  ON_SUGGESTION_SELECT: 'onSuggestionSelect',
  ON_SUGGESTION_GROUP_SELECT: 'onSuggestionGroupSelect',
  ON_SUGGESTIONS_FOOTER_CLICK: 'onSuggestionsFooterClick',

  // NOTE this values without `on` prefix because of backward-compatibility
  ON_SUBMIT: 'submit',
  ON_CHANGE: 'change',

  // NOTE this values without `on` prefix because comes from mixins
  ON_FOCUS: 'focus',
  ON_BLUR: 'blur',
};
